import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/col/index.js
// module id = null
// module chunks = 